<script lang="ts" setup>
definePage({
	name: "school.teacher-search.hired-teachers",
});
</script>

<template>
	<div id="hired-teachers"></div>
</template>
